import React from 'react';
import { cn } from '@/utils/cn';

interface PageShellProps {
  /** Content rendered in the always-visible top bar (title, subtitle, action button, back link). */
  header: React.ReactNode;
  /** Scrollable page body. */
  children: React.ReactNode;
  /** Tailwind max-width class, e.g. "max-w-5xl". Defaults to "max-w-5xl". */
  maxWidth?: string;
}

const PageShell: React.FC<PageShellProps> = ({ header, children, maxWidth = 'max-w-5xl' }) => (
  <div className="h-full flex flex-col">
    {/* Fixed header — never scrolls */}
    <div className="bg-ui-card border-b border-ui-border shadow-sm shrink-0">
      <div className={cn('w-full mx-auto px-4 sm:px-6 lg:px-8 py-4', maxWidth)}>
        {header}
      </div>
    </div>

    {/* Scrollable content */}
    <div className="flex-1 overflow-y-auto">
      <div className={cn('w-full mx-auto px-4 sm:px-6 lg:px-8 py-6', maxWidth)}>
        {children}
      </div>
    </div>
  </div>
);

export default PageShell;
